export default __webpack_public_path__ + "static/media/sidearrow.12282487.svg";